import { AloPanier } from '@/models/alo/AloPanier';
import { StateItem, buildStateItem } from '@/models/alo/StateItem';

export interface IClientState {     
        
    panier:AloPanier    
    panierStatus:string
}

var pan = localStorage.getItem('aqua_panier') 

//Initial State
const state: IClientState = {            
    panier: pan?new AloPanier(JSON.parse(pan)):new AloPanier(),
    panierStatus:''
}
export default state